var cov_1cngjhp73r = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Rate/styles/index.ts",
      hash = "a36e33ebce512137a2c03b4d2e26ea92421502f3",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Rate/styles/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 25
        },
        end: {
          line: 5,
          column: 53
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var rateLess = {};
import genaration from '../../utils/classname';
export var rateClass = (cov_1cngjhp73r.s[0]++, genaration(rateLess, 'rate'));